// utils/snackbarUtils.js
import { useSnackbar } from 'notistack';

let snackbarRef;

export const SnackbarUtilsConfigurator = () => {
  snackbarRef = useSnackbar();
  return null;
};

const SnackbarUtils = {
  success(msg) {
    this.toast(msg, 'success');
  },
  error(msg) {
    this.toast(msg, 'error');
  },
  info(msg) {
    this.toast(msg, 'info');
  },
  warning(msg) {
    this.toast(msg, 'warning');
  },
  toast(msg, variant = 'default') {
    snackbarRef.enqueueSnackbar(msg, { variant });
  },
};

export default SnackbarUtils;
